const goBack = () => {
  document.referrer ? window.location.href = document.referrer : ""
}

// const scrollToMedia = (mediaElement) => { 
//   mediaElement.scrollIntoView({ block: 'center' });
//   window.scrollBy(0, -40);
// }

// setTimeout(() => {
//     document.querySelector(".abz-main-product .product__media .flickity-prev-next-button.next")
//       .addEventListener('click', () => scrollToMedia(document.querySelector(".abz-main-product .product__media")) )

// 	document.querySelector(".abz-main-product .product__media .flickity-prev-next-button.previous")
//       .addEventListener('click', () => scrollToMedia(document.querySelector(".abz-main-product .product__media")) )
// }, 1000);